export const SIGNUP_USED_FLAG = "signupUsed";
